import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';
import type { GetTikTokAdvertisersAction } from './getAdvertisers.action';
import type { GetTikTokAuthenticationUrlAction } from './getAuthenticationUrl.action';

export * from './getAdvertisers.action';
export * from './getAuthenticationUrl.action';

export type TikTokAction = GetTikTokAuthenticationUrlAction | GetSanAdAccountZeitStatusAction | GetTikTokAdvertisersAction;
